import axiosInstance from "../axios/axios_instance"
const http = axiosInstance("/protected",  null, "/dashboard")

const sendAccredReqEmail = () => http.post('/send_accred_req_email')

export default {
    sendAccredReqEmail,
}